module.exports = __webpack_public_path__ + "img/share.33b16476.jpg";